export const envs = Object.freeze({
  apiBaseUrl: '/proxy',
  apiBaseTokenUrl: '/getToken',
  useParamsForBanner:
    window.location.host.includes('brands.wakefern.com') === true,
});
